module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-service-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.services.title')))]), _vm._v(" "), (!_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel;
        _vm.editMode = false;
        _vm.clearFormError();
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel;
        _vm.service = Object.assign({}, _vm.defaultService);
        _vm.clearFormError()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.list')))]) : _vm._e()]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "service-wrapper"
  }, [(!!_vm.services.length > 0) ? _c('div', [_c('draggable', {
    on: {
      "end": _vm.onServiceDraggableEnd
    },
    model: {
      value: (_vm.services),
      callback: function($$v) {
        _vm.services = $$v
      },
      expression: "services"
    }
  }, [_c('transition-group', _vm._l((_vm.services), function(s, index) {
    return _c('div', {
      key: index,
      staticClass: "service-container"
    }, [_c('div', {
      staticClass: "service-content",
      on: {
        "click": function($event) {
          _vm.editService(s)
        }
      }
    }, [_c('h6', [_vm._v(_vm._s(s.th.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(s.th.description))]), _vm._v(" "), (s.is_price_range) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.price')))]), _vm._v(" " + _vm._s(s.price_from) + " - " + _vm._s(s.price_to) + "\n                  ")]) : _vm._e(), _vm._v(" "), (s.is_price_from) ? _c('div', [_c('strong', [_vm._v("ราคาเริ่มต้น ")]), _vm._v(" " + _vm._s(s.price_from) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!s.is_price_range && !s.is_price_from) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.price')))]), _vm._v(" " + _vm._s(s.price) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "service-actions"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          _vm.editService(s)
        }
      }
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('action_message.edit')))])]) : _vm._e()])])
  }))], 1)], 1) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.services.no_services')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('div', {
    staticClass: "service-form"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.services.add_new_service')))]), _vm._v(" "), _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom",
    attrs: {
      "label": _vm.$t('message.services.service_name_th'),
      "placeholder": _vm.$t('message.services.service_name_th')
    },
    model: {
      value: (_vm.service.th.name),
      callback: function($$v) {
        _vm.service.th.name = $$v
      },
      expression: "service.th.name"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.name']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1), _vm._v(" "), _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom",
    attrs: {
      "label": _vm.$t('message.services.service_name_en'),
      "placeholder": _vm.$t('message.services.service_name_en')
    },
    model: {
      value: (_vm.service.en.name),
      callback: function($$v) {
        _vm.service.en.name = $$v
      },
      expression: "service.en.name"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.name']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.services.select_duration')))]), _vm._v(" "), _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-min",
    attrs: {
      "type": "Number",
      "min": "1",
      "max": "59",
      "placeholder": _vm.$t('message.services.service_duration')
    },
    model: {
      value: (_vm.service.duration),
      callback: function($$v) {
        _vm.service.duration = $$v
      },
      expression: "service.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.minutes')))])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.duration
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.services.price')) + "  \n          "), _c('div', {
    staticClass: "form-check form-check-inline",
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceOption),
      expression: "priceOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "basicInlineRadios",
      "value": "price_default"
    },
    domProps: {
      "checked": _vm._q(_vm.priceOption, "price_default")
    },
    on: {
      "__c": function($event) {
        _vm.priceOption = "price_default"
      }
    }
  }), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceOption),
      expression: "priceOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "basicInlineRadios",
      "value": "price_range"
    },
    domProps: {
      "checked": _vm._q(_vm.priceOption, "price_range")
    },
    on: {
      "__c": function($event) {
        _vm.priceOption = "price_range"
      }
    }
  }), _c('label', {
    staticClass: "form-check-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.services.price_range')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceOption),
      expression: "priceOption"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "basicInlineRadios",
      "value": "price_from"
    },
    domProps: {
      "checked": _vm._q(_vm.priceOption, "price_from")
    },
    on: {
      "__c": function($event) {
        _vm.priceOption = "price_from"
      }
    }
  }), _vm._m(1)])]), _vm._v(" "), (!_vm.service.is_price_range && !_vm.service.is_price_from) ? _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price')
    },
    model: {
      value: (_vm.service.price),
      callback: function($$v) {
        _vm.service.price = $$v
      },
      expression: "service.price"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')))])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.service.is_price_range) ? _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price_from')
    },
    model: {
      value: (_vm.service.price_from),
      callback: function($$v) {
        _vm.service.price_from = $$v
      },
      expression: "service.price_from"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')) + " (" + _vm._s(_vm.$t('message.services.price_from')) + ")")])])]), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price_to')
    },
    model: {
      value: (_vm.service.price_to),
      callback: function($$v) {
        _vm.service.price_to = $$v
      },
      expression: "service.price_to"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')) + " (" + _vm._s(_vm.$t('message.services.price_to')) + ")")])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_from
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_10
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.service.is_price_from) ? _c('div', [_c('bs-input', {
    staticClass: "remove-padding-bottom input-price-range",
    attrs: {
      "placeholder": _vm.$t('message.services.price_from')
    },
    model: {
      value: (_vm.service.price_from),
      callback: function($$v) {
        _vm.service.price_from = $$v
      },
      expression: "service.price_from"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('message.services.baht')) + " (" + _vm._s(_vm.$t('message.services.price_from')) + ")")])])]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_from
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.price_10
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.services.service_detail')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.services.service_detail_th'),
      "placeholder": _vm.$t('message.services.service_detail_th')
    },
    model: {
      value: (_vm.service.th.description),
      callback: function($$v) {
        _vm.service.th.description = $$v
      },
      expression: "service.th.description"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.services.service_detail_en'),
      "placeholder": _vm.$t('message.services.service_detail_en')
    },
    model: {
      value: (_vm.service.en.description),
      callback: function($$v) {
        _vm.service.en.description = $$v
      },
      expression: "service.en.description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelAddingService
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addService
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-service-action",
    on: {
      "click": _vm.removeService
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-check-label"
  }, [_c('span', [_vm._v("ปรกติ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-check-label"
  }, [_c('span', [_vm._v("ราคาเริ่มต้น")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b53302ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/steps/Services.vue
// module id = 1049
// module chunks = 1